import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { ItemDiscountAdminDto } from '@/backend/market'
import { OrderItemsEntity } from '../../domain/entities/OrderItemsEntity'

export class OrderItemsModel extends OrderItemsEntity {
  constructor(dataDto: ItemDiscountAdminDto) {
    super()
    mapEntityProperties<OrderItemsEntity>(this, dataDto)
  }
}
